__webpack_require__.p = "/BugJarBattles/";